<template>
  <div class="contenedor">
    <AmountSelector
      v-model="amount"
      :amounts="amounts"
      :currency="currency"
      :disabled="isLoading"
      :show-error="showError"
      @amount-selected="handleAmountSelected"
    />
    
    <!-- Mostrar el botón de depósito o el spinner si se está procesando -->
    <button 
      class="deposit" 
      @click="submitDeposit" 
      :disabled="isLoading || amount < 1"
    >
      <span v-if="isLoading">Processing...</span>
      <span v-else style="color:black">Deposit</span>
    </button>
  </div>
</template>

<script>
import AmountSelector from './AmountSelector.vue';

export default {
  name: 'DepositForm',
  components: {
    AmountSelector
  },
  props: {
    username: {
      type: String,
      required: true
    },
    amounts: {
      type: Array,
      default: () => [1, 2, 5, 10, 20, 30, 50, 100, 200, 300, 500, 700, 1000]
    },
    currency: {
      type: String,
      default: 'LSL'
    },
    apiUrl: {
      type: String,
      required: true
    }
  },
  emits: ['deposit-submitted', 'deposit-success', 'deposit-error', 'show-otp'],
  data() {
    return {
      amount: null,
      showError: false,
      isLoading: false
    };
  },
  methods: {
    validateAmount() {
      this.showError = this.amount !== null && this.amount < 1;
    },
    async handleAmountSelected(value) {
      this.amount = value;
      this.showError = false;
      await this.submitDeposit();
    },
    async submitDeposit() {
      if (this.amount < 1) {
        this.showError = true;
        this.$emit('deposit-error', "Amount must be at least 1 LSL.");
        return;
      }

      this.isLoading = true;
      this.$emit('deposit-submitted');

      const data = {
        username: this.username,
        amount: this.amount,
      };

      try {
        const response = await fetch(`${this.apiUrl}/api/deposit/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Unknown error occurred");
        }

        // Verificar si la respuesta fue exitosa basándonos en el código
        if (result.code === 0) {
          // Si la respuesta es exitosa, mostrar el componente OTP
          if (result.data.status_code === 200) {
            this.$emit('show-otp', {
              transactionData: result.data,
              amount: this.amount,
              username: this.username
            });
          } else {
            let message = "<h2>" + result.data.description + "</h2>";
            message += "External Reference: " + result.data.conversation_id;
            this.$emit('deposit-error', message);
          }
        } else {
          this.$emit('deposit-error', "Deposit failed: " + result.message);
        }
        
      } catch (error) {
        console.error("Error submitting deposit:", error);
        this.$emit('deposit-error', error.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    amount() {
      this.validateAmount();
    }
  }
};
</script>

<style scoped>
.contenedor {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  display: inherit;
  background-color: #e7e7e7;
  align-content: center;
  justify-items: center;
}

.deposit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-width: 275px;
  margin-top: 10px;
  padding: 10px 20px;
  cursor: pointer;
  color: black;
  background-color: #cddc39;
  border: 2px solid #cddc39;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.deposit:hover:not(:disabled) {
  border: 2px solid #0e9e29;
  background-color: #b7dc39;
}

.deposit:disabled {
  cursor: not-allowed;
  background-color: #ccc;
}
</style>
